import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from "./state";

export const Minigames = {
    namespaced: true,
    persist: true,
    state,
    actions,
    mutations,
    getters
};

export default Minigames;